const MAX_RATING = 5;

const STARS = [1, 2, 3, 4, 5];

/**
 * Renders a 1–5 star rating. The run of stars is exposed to assistive
 * technology as a single image with a text alternative, so screen readers
 * announce "4 out of 5 stars" rather than five separate graphics.
 */
export function StarRating({ rating }: { rating: number }) {
  return (
    <p
      aria-label={`${rating} out of ${MAX_RATING} stars`}
      className="testimonials2-rating"
      role="img"
    >
      {STARS.map((star) => (
        <svg
          aria-hidden="true"
          className={`testimonials2-star${
            star <= rating ? " testimonials2-star--filled" : ""
          }`}
          focusable="false"
          key={star}
          viewBox="0 0 24 24"
        >
          <path d="M12 1.6l3.09 6.9 7.41.74-5.56 5.1 1.6 7.46L12 17.98 5.46 21.8l1.6-7.46L1.5 9.24l7.41-.74z" />
        </svg>
      ))}
    </p>
  );
}
